export default __webpack_public_path__ + "static/media/BootcampDesktop.4f0d25db.png";